<template>
  <div>
    <main-template>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col class="d-flex align-center">
              <v-btn color="primary" x-small text @click="goBack">
                <v-icon left> fa fa-angle-left </v-icon>
              </v-btn>
              <h1>Planejamento de Aulas</h1>
              <e-help-tooltip
                :text="$constants.tooltips.diarioOnline.planejamentoDeAulas"
              ></e-help-tooltip>
            </v-col>
          </v-row>

          <v-col cols="12" class="pt-3 px-0 mt-3">
            <div class="d-flex justify-space-between align-center">
              <v-btn color="primary" @click="handleGoToCreatePlanejamento">
                <v-icon left small>mdi-plus</v-icon>
                Criar Novo Planejamento
              </v-btn>
              <v-text-field
                v-model="search"
                class="ml-2 search-input"
                append-icon="mdi-magnify"
                label="Pesquisar..."
                solo
                dense
                single-line
                hide-details
                style="max-width: 400px"
              />
            </div>
          </v-col>

          <v-col cols="12" class="pt-15">
            <v-progress-linear v-if="loading" indeterminate color="primary" />

            <div v-if="!loading && !filteredPlanejamentos.length" class="text-center py-8">
              <v-icon size="64" color="grey lighten-1">mdi-calendar-blank</v-icon>
              <p class="text-h5 grey--text mt-4">Nenhum planejamento encontrado</p>
            </div>

            <v-expansion-panels v-if="!loading" accordion>
              <v-expansion-panel
                v-for="planejamento in filteredPlanejamentos"
                :key="planejamento.id"
                class="mb-3"
              >
                <v-expansion-panel-header>
                  <div class="planejamento-info">
                    <v-avatar size="50" color="primary">
                      <v-icon dark>mdi-calendar-check</v-icon>
                    </v-avatar>

                    <div class="flex-grow-1">
                      <div
                        class="text-subtitle-1 font-weight-medium"
                        style="font-size: 1.1rem !important"
                      >
                        # {{ planejamento.id }} - {{ planejamento.escola }}
                      </div>
                      <div class="text-body-2 grey--text font-weight-bold">
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        {{ formatarDia(planejamento.data) }}
                      </div>
                    </div>

                    <div class="d-flex flex-column align-end">
                      <v-chip color="primary" text-color="white" class="mb-1">
                        {{ planejamento.professoresPresentes }}/{{ planejamento.qtdProfessores }}
                        Presentes
                      </v-chip>
                    </div>
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="professores-container">
                    <v-divider class="my-4" />

                    <div class="d-flex justify-space-between align-center mb-6">
                      <h4 class="text-h7">Professores ({{ planejamento.professores.length }})</h4>
                      <div class="d-flex">
                        <v-btn small @click="RelatorioPlanejamentoAulas(planejamento.id)">
                          <v-icon small left>mdi-book</v-icon>
                          Gerar Relatório do Planejamento
                        </v-btn>
                        <v-btn class="ml-3" small @click="EditarPlanejamento(planejamento.id)">
                          <v-icon small left>mdi-book</v-icon>
                          Editar Planejamento
                        </v-btn>
                        <v-btn
                          color="error"
                          small
                          class="ml-3"
                          @click="deletePlanejamento(planejamento.id)"
                        >
                          <v-icon small left>mdi-delete</v-icon>
                          Deletar Planejamento
                        </v-btn>
                      </div>
                    </div>

                    <v-row>
                      <v-col
                        v-for="professor in planejamento.professores"
                        :key="`${professor.id}-${professor.planejamento_aula_id}`"
                        cols="12"
                      >
                        <v-card class="professor-card elevation-2" outlined>
                          <v-card-text>
                            <v-row align="center">
                              <v-col cols="12" sm="4" md="3">
                                <div class="d-flex align-center">
                                  <v-avatar size="40" class="mr-3">
                                    <v-icon dark small>mdi-account</v-icon>
                                  </v-avatar>
                                  <div>
                                    <div class="text-subtitle-2 font-weight-medium">
                                      {{ professor.nome }}
                                    </div>
                                    <v-chip
                                      v-if="
                                        professor.presenca === 'Faltou' &&
                                        professor.justificativa_id
                                      "
                                      x-small
                                      color="primary"
                                      text-color="white"
                                      class="mt-1"
                                    >
                                      <v-icon x-small left>mdi-check-circle</v-icon>
                                      Justificado
                                    </v-chip>
                                  </div>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="8" md="9">
                                <div class="d-flex align-center flex-wrap">
                                  <v-btn-toggle
                                    v-model="professor.presenca"
                                    mandatory
                                    dense
                                    class="frequencia-toggle"
                                  >
                                    <v-btn
                                      small
                                      value="Presente"
                                      color="green darken-1"
                                      outlined
                                      @click="
                                        registrarPresenca(planejamento.id, professor.id, true)
                                      "
                                    >
                                      <v-icon small left>mdi-check</v-icon>
                                      Presente
                                    </v-btn>
                                    <v-btn
                                      small
                                      value="Faltou"
                                      color="error"
                                      outlined
                                      @click="
                                        registrarPresenca(planejamento.id, professor.id, false)
                                      "
                                    >
                                      <v-icon small left>mdi-close</v-icon>
                                      Falta
                                    </v-btn>

                                    <div>
                                      <v-btn
                                        v-if="professor.presenca === 'Faltou'"
                                        class="ml-5"
                                        small
                                        color="primary"
                                        outlined
                                        @click="abrirModalJustificativa(planejamento.id, professor)"
                                      >
                                        <v-icon small left>mdi-clipboard-text</v-icon>
                                        Justificar Falta
                                      </v-btn>
                                    </div>
                                  </v-btn-toggle>

                                  <v-tooltip
                                    v-if="
                                      professor.presenca === 'Faltou' &&
                                      professor.justificativa_id &&
                                      professor.hasDocument
                                    "
                                    bottom
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        x-small
                                        class="ml-2"
                                        color="red lighten-5"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="
                                          documentoJustificativaFalta(planejamento.id, professor.id)
                                        "
                                      >
                                        <v-icon color="red lighten-1" small>
                                          fa fa-file-pdf
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Baixar documento</span>
                                  </v-tooltip>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <scroll-top
                    @click.native.prevent="scrollToTop"
                    :threshold="300"
                    :bottom="86"
                    :right="24"
                    color="primary"
                    icon="mdi-arrow-up-bold"
                    small
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Confirmar Exclusão</v-card-title>
          <v-card-text style="font-size: 16px">
            Tem certeza que deseja deletar o planejamento de aulas
            <strong>{{ itemToDelete?.escola }}</strong>
            do dia
            <strong>{{ itemToDelete ? formatarDia(itemToDelete.data) : "" }}</strong
            >?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="dialogDelete = false"> Cancelar </v-btn>
            <v-btn color="error" text @click="confirmDelete"> Deletar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <e-modal-justificar-falta-professor-planejamento
        v-if="modalJustificativaAberto && planejamentoSelecionado && professorSelecionado"
        v-model="modalJustificativaAberto"
        :planejamento-aula-id="planejamentoSelecionado"
        :professor="professorSelecionado"
        :justificativa-id="justificativaIdSelecionada"
        @sucesso="onJustificativaSalva"
      />
    </main-template>
  </div>
</template>

<script>
import EHelpTooltip from "@/components/EHelpTooltip.vue";
import EModalJustificarFaltaProfessorPlanejamento from "@/components/EModalJustificarFaltaProfessorPlanejamento.vue";

export default {
  components: { EHelpTooltip, EModalJustificarFaltaProfessorPlanejamento },
  name: "PlanejamentoAulasPage",

  data() {
    return {
      search: "",
      loading: false,
      planejamentosList: [],
      isScrolled: false,
      dialogDelete: false,
      itemToDelete: null,
      presenca: null,
      modalJustificativaAberto: false,
      planejamentoSelecionado: null,
      professorSelecionado: null,
      justificativaIdSelecionada: null,
    };
  },

  computed: {
    filteredPlanejamentos() {
      if (!this.search) return this.planejamentosList;
      const termo = this.search.toLowerCase();
      return this.planejamentosList.filter((p) => {
        const escola = (p.escola || "").toLowerCase();
        const data = this.formatarDia(p.data);
        return escola.includes(termo) || data.includes(termo);
      });
    },
  },

  mounted() {
    this.loadPlanejamentos();
  },

  methods: {
    goBack() {
      this.$router.push({ name: "home" });
    },
    async documentoJustificativaFaltaPlanejamento(professor_id, planejamento_aula_id) {
      await this.$services.relatoriosService.documentoJustificativaFaltaPlanejamento(
        parseInt(professor_id, 10),
        parseInt(planejamento_aula_id, 10)
      );
    },
    async loadPlanejamentos() {
      this.loading = true;
      try {
        const response = await this.$services.gestoesDeAulasService.listarPlanejamentoAulas();
        console.log(response);

        this.planejamentosList = response;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },

    abrirModalJustificativa(planejamento_aula_id, professor) {
      this.planejamentoSelecionado = planejamento_aula_id;
      this.professorSelecionado = professor;
      this.justificativaIdSelecionada = professor.justificativa_id || null;
      this.modalJustificativaAberto = true;
    },

    onJustificativaSalva(data) {
      const planejamento = this.planejamentosList.find(
        (p) => p.id === this.planejamentoSelecionado
      );

      const professor = planejamento.professores.find((p) => p.id === data.professor_id);

      this.$set(professor, "justificativa_id", data.justificativa_id);
      this.$set(professor, "hasDocument", data.hasDocument);
      this.$set(professor, "temJustificativa", true);

      this.modalJustificativaAberto = false;
    },

    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    handleGoToCreatePlanejamento() {
      this.$router.push({ name: "gestoesDeAulas.planejamentoDeAulas.create" });
    },

    async registrarPresenca(planejamento_aula_id, professor_id, presenca) {
      try {
        await this.$services.gestoesDeAulasService.registrarPresencaPlanejamentoAula(
          planejamento_aula_id,
          professor_id,
          presenca
        );

        const planejamento = this.planejamentosList.find((p) => p.id === planejamento_aula_id);

        const professor = planejamento.professores.find((p) => p.id === professor_id);

        this.$set(professor, "presenca", presenca ? "Presente" : "Faltou");

        if (presenca) {
          this.$set(professor, "hasDocument", false);
          this.$set(professor, "justificativa_id", null);
        }

        this.$set(professor, "temJustificativa", !presenca);

        planejamento.professoresPresentes = planejamento.professores.filter(
          (p) => p.presenca === "Presente"
        ).length;

        this.$toast.success("Planejamento atualizado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
    },

    EditarPlanejamento(planejamento_aula_id) {
      this.$router.push({
        name: "gestoesDeAulas.planejamentoDeAulas.edit",
        params: { planejamentoDeAulaId: planejamento_aula_id },
      });
    },

    deletePlanejamento(planejamento_aula_id) {
      this.planejamentoToDelete = planejamento_aula_id;
      this.dialogDelete = true;
    },

    async confirmDelete() {
      try {
        this.$loaderService.open();
        await this.$services.gestoesDeAulasService.deletarPlanejamentoAula(
          this.planejamentoToDelete
        );
        this.$toast.success("Planejamento deletado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        await this.loadPlanejamentos();
        this.dialogDelete = false;
        this.planejamentoToDelete = null;
        this.$loaderService.close();
      }
    },

    async documentoJustificativaFalta(planejamento_aula_id, professor_id) {
      this.$loaderService.open("Baixando...");
      try {
        await this.$services.gestoesDeAulasService.baixarDocumentoJustificativaPlanejamento(
          parseInt(planejamento_aula_id, 10),
          parseInt(professor_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async RelatorioPlanejamentoAulas(planejamento_aula_id) {
      try {
        this.$loaderService.open();
        await this.$services.relatoriosService.RelatorioPlanejamentoAulas(planejamento_aula_id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.planejamento-info {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.professor-card {
  border-left: 4px solid;
  transition: all 0.3s ease;
}

.border-success {
  border-left-color: #4caf50 !important;
}

.border-error {
  border-left-color: #f44336 !important;
}

.border-warning {
  border-left-color: #ff9800 !important;
}

.border-grey {
  border-left-color: #9e9e9e !important;
}

.professor-card:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.professores-container {
  padding: 0 8px;
  position: relative;
}

.resumo-card {
  background-color: #fafafa;
}

.frequencia-toggle {
  flex: 1;
}

.frequencia-toggle .v-btn {
  flex: 1;
}

.search-input {
  max-width: 400px;
}

/* Responsividade */
@media (max-width: 960px) {
  .planejamento-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .planejamento-info > div:last-child {
    align-self: flex-end;
  }
}

@media (max-width: 600px) {
  .frequencia-toggle {
    flex-direction: column;
  }

  .frequencia-toggle .v-btn {
    width: 100%;
    margin-bottom: 4px;
  }
}
</style>
